import * as React from 'react';
import { SVGProps } from 'react';

export const Discount = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5363 5H6.875C6.37773 5 5.9008 5.19754 5.54918 5.54917C5.19755 5.9008 5 6.37771 5 6.875V14.535C4.99989 14.7812 5.04829 15.0251 5.14245 15.2527C5.2366 15.4802 5.37466 15.6871 5.54875 15.8612L17 27.315C17.2219 27.5368 17.4958 27.6993 17.7968 27.7878C18.0978 27.8763 18.4161 27.888 18.7226 27.8215C19.0292 27.7551 19.3142 27.6128 19.5516 27.4077C19.789 27.2026 19.9711 26.9412 20.0812 26.6475L21.875 21.875L26.6488 20.0837C26.9425 19.9736 27.2039 19.7915 27.409 19.5541C27.6141 19.3167 27.7564 19.0317 27.8228 18.7252C27.8893 18.4186 27.8776 18.1002 27.7891 17.7992C27.7006 17.4983 27.538 17.2243 27.3162 17.0025L15.8612 5.54875C15.5097 5.19747 15.0332 5.0001 14.5363 5Z"
      stroke="#071114"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.625 11.0938C10.3661 11.0938 10.1562 10.8839 10.1562 10.625C10.1562 10.3661 10.3661 10.1562 10.625 10.1562"
      stroke="#071114"
      strokeWidth="1.5"
    />
    <path
      d="M10.625 11.0938C10.8839 11.0938 11.0938 10.8839 11.0938 10.625C11.0938 10.3661 10.8839 10.1562 10.625 10.1562"
      stroke="#071114"
      strokeWidth="1.5"
    />
  </svg>
);
export default Discount;
